import { View } from "binder"
import { ClassViewModel } from "./class-viewModel"

export class ClassView extends View<ClassViewModel>{
    GetViewUniqueId(): string {
        return "V-6FBE1072-3F37-4A39-9FF1-9C2E0B6C1E45"
    }
    loadHtml(): string {
        let element = require('./class.html').default;
        let style = require('./class.less');
        return element;
    }
    constructor() {
       super();
    }
}
